(function () {
  var DISCOUNT = 0.9;
  var WRITING = new WeakSet();

  function money(cents) {
    var whole = Math.round(cents) / 100;
    return '$' + whole.toLocaleString('en-AU', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  function parseMoney(text) {
    if (!text) return null;
    var m = text.replace(/[^0-9.]/g, '');
    if (!m) return null;
    var f = parseFloat(m);
    if (isNaN(f)) return null;
    return Math.round(f * 100);
  }

  function rewrite(priceList) {
    if (!priceList || WRITING.has(priceList)) return;
    var onSale = priceList.querySelector(':scope > .price--on-sale, :scope > div.price.price--on-sale');
    if (onSale) {
      var reg = onSale.querySelector('.price-item--regular');
      var sale = onSale.querySelector('.price-item--sale');
      if (!reg || !sale) return;
      var compareCents = parseMoney(reg.textContent);
      var saleCents = parseMoney(sale.textContent);
      if (compareCents == null || saleCents == null) return;
      var discounted = money(saleCents * DISCOUNT);
      var compareTxt = money(compareCents);
      var newHTML =
        '<span class="price price--highlight">' +
        '<span class="visually-hidden">Sale price</span>' + discounted +
        '</span>' +
        '<span class="price price--compare">' +
        '<span class="visually-hidden">Regular price</span>' + compareTxt +
        '</span>';
      WRITING.add(priceList);
      priceList.innerHTML = newHTML;
      setTimeout(function () { WRITING.delete(priceList); }, 0);
      return;
    }
    var solo = priceList.querySelector(':scope > .price-item--regular, :scope > span.price-item--regular');
    if (solo && !priceList.querySelector('.price--highlight, .price--compare')) {
      var cents = parseMoney(solo.textContent);
      if (cents == null) return;
      var d = money(cents * DISCOUNT);
      var soloHTML =
        '<span class="price">' +
        '<span class="visually-hidden">Sale price</span>' + d +
        '</span>';
      WRITING.add(priceList);
      priceList.innerHTML = soloHTML;
      setTimeout(function () { WRITING.delete(priceList); }, 0);
    }
  }

  function scanAll() {
    document.querySelectorAll('product-item .price-list').forEach(rewrite);
  }

  var obs = new MutationObserver(function (mutations) {
    var touched = new Set();
    for (var i = 0; i < mutations.length; i++) {
      var m = mutations[i];
      var t = m.target;
      var pl = t && t.closest ? t.closest('.price-list') : null;
      if (pl && !touched.has(pl)) {
        touched.add(pl);
      }
      for (var j = 0; j < m.addedNodes.length; j++) {
        var n = m.addedNodes[j];
        if (n && n.nodeType === 1 && n.classList && n.classList.contains('price--on-sale')) {
          var pl2 = n.closest('.price-list');
          if (pl2) touched.add(pl2);
        }
      }
    }
    touched.forEach(function (pl) {
      if (pl.closest('product-item')) rewrite(pl);
    });
  });

  function boot() {
    obs.observe(document.body, { childList: true, subtree: true });
    scanAll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
